

import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { UIComponentHandler, UIDataModel } from '../../../../toolkit/uicomponent';
import { UIComponentView } from '../../../../toolkit/uicomponentview';
import { PopUpWrapperComponent } from '../../popupwrappercomponent';
import { FlashPopUpWrapperViewImpl } from './flashpopupwrapperview';






export class FlashPopUpWrapperComponent extends PopUpWrapperComponent
{
    
    
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new FlashPopUpWrapperViewImpl(applicationContext, uiComponentHandler);
    }

   
    

    
    
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/flashpopup/flashwrapper/flashpopupwrappercomponent.tsx